/**
 * orga app | admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AbrechnungMandantOptions { 
    status?: string;
    naechste_rechnung?: string;
    laufzeit_bis?: string;
    letzte_aktion?: string;
    bemerkung?: string;
    hot_seat?: string;
    provisionierungs_zyklus?: string;
    ablaufdatum_zertifikate?: string;
    rechnung_mail_to?: string;
    rechnung_mail_cc?: string;
    rechnung_mail_body?: string;
    rechnung_mail_subject?: string;
}

